import React, { useState } from "react";
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@components/ui/select";
import { Button } from "@components/ui/button";
import { PlusCircle, Loader } from "lucide-react";
import AnomalyDefeatItem from "./AnomalyDefeatItem";
import { UsecaseContext } from "@services/providers/UsecaseProvider";
import AnomalyMeta from "./AnomalyMeta";

const AnomalyDefeat: React.FC = () => {
  const { DefeatData, updateDefeatData, metaMapping, CurrentView } =
    React.useContext(UsecaseContext);
  const [type, setType] = useState("includeMeta");

  React.useEffect(() => {
    if (DefeatData) {
      if (DefeatData.excludeMeta.length > 0) {
        setType("excludeMeta");
      } else {
        setType("includeMeta");
      }
    }
  }, [DefeatData]);

  function addCondition() {
    let lastid = 0;
    const items = DefeatData[type];
    if (items.length > 0) {
      lastid = items[items.length - 1].metaId;
    }

    const newItem = {
      metaId: lastid + 1,
      condition: "",
      values: [],
    };

    updateDefeatData({
      ...DefeatData,
      [type]: [...items, newItem],
    });
  }

  if ("user" in metaMapping == false && "entity" in metaMapping == false) {
    return (
      <div className="w-full border p-2 rounded-md flex py-4 gap-4 items-center">
        <Loader className="animate-spin" size={30} />
        <div>Loading...</div>
      </div>
    );
  }

  return (
    <>
      <div className="w-full border p-2 rounded-md">
        <div className="w-full grid grid-cols-2 gap-2">
          <div className="col-span-1 mt-auto">
            <div className="inline-block underline h-full mt-auto underline-offset-4 decoration-1 me-4">
              The anomaly will trigger if:
            </div>
            <div className="inline-block">
              <Select
                onValueChange={(e: string) => setType(e)}
                defaultValue="includeMeta"
                value={type}
              >
                <SelectTrigger className="w-[120px] mb-4">
                  <SelectValue placeholder="Include" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="includeMeta">Include</SelectItem>
                    <SelectItem value="excludeMeta">Exclude</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
          <div className="col-span-1 text-right">
            <Button variant="default" onClick={addCondition}>
              <PlusCircle size={14} className="me-2" /> <span>Add Meta</span>
            </Button>
          </div>
        </div>
        {CurrentView == "anomaly" || CurrentView == "event" ? (
          <div>
            {DefeatData &&
              type == "includeMeta" &&
              DefeatData["includeMeta"].map((item: any, index: number) => (
                <AnomalyMeta
                  key={index}
                  className="mb-2"
                  data={item}
                  label={index == 0 ? "IF" : "AND IF"}
                  type="includeMeta"
                />
              ))}
            {DefeatData &&
              type == "excludeMeta" &&
              DefeatData["excludeMeta"].map((item: any, index: number) => (
                <AnomalyMeta
                  key={index}
                  className="mb-2"
                  data={item}
                  label={index == 0 ? "IF" : "AND IF"}
                  type="excludeMeta"
                />
              ))}
          </div>
        ) : (
          <div>
            <div
              className={"w-full " + (type == "includeMeta" ? "" : "hidden")}
            >
              {DefeatData &&
                DefeatData["includeMeta"].map((item: any, index: number) => (
                  <AnomalyDefeatItem
                    key={index}
                    className="mb-2"
                    data={item}
                    type="includeMeta"
                  />
                ))}
            </div>
            <div
              className={"w-full " + (type == "excludeMeta" ? "" : "hidden")}
            >
              {DefeatData &&
                DefeatData["excludeMeta"].map((item: any, index: number) => (
                  <AnomalyDefeatItem
                    key={index}
                    className="mb-2"
                    data={item}
                    type="excludeMeta"
                  />
                ))}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default AnomalyDefeat;
